"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultWidgetSelect = exports.usePropertiesFilter = exports.useSupportedWidgets = void 0;
const react_1 = require("react");
const ramda_1 = require("ramda");
const useSupportedWidgets = (schemes, uiSchema) => {
    return (0, react_1.useMemo)(() => {
        var _a;
        const particular = (_a = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:widgets']) !== null && _a !== void 0 ? _a : [];
        if (particular.domain) {
            const selector = particular;
            return schemes.filter(({ domain, placement }) => {
                if (selector.domain === domain) {
                    if (!selector.placement) {
                        return true;
                    }
                    else {
                        return selector.placement === placement;
                    }
                }
                return false;
            });
        }
        const selector = particular;
        if (!selector.length) {
            return schemes;
        }
        const selectorSet = new Set(selector.map(String));
        return schemes.filter(({ id, name }) => selectorSet.has(id.toString()) || selectorSet.has(name.toString()));
    }, [uiSchema, schemes]);
};
exports.useSupportedWidgets = useSupportedWidgets;
const usePropertiesFilter = (schema, uiSchema, arrayPropNameToSkip) => {
    return (0, react_1.useMemo)(() => {
        var _a;
        const jsonSchema = schema === null || schema === void 0 ? void 0 : schema.jsonSchema;
        const arrayPropName = arrayPropNameToSkip || 'ui:skip';
        const skip = (_a = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema[arrayPropName]) !== null && _a !== void 0 ? _a : [];
        if (!skip.length || !jsonSchema) {
            return schema;
        }
        // can be used structuredClone, see can i use
        let filtered = JSON.parse(JSON.stringify(jsonSchema));
        skip.forEach((property) => {
            const objPath = property.split('.');
            if (!objPath.length || !(0, ramda_1.path)(objPath, filtered)) {
                return;
            }
            const last = objPath.pop();
            filtered = (0, ramda_1.assocPath)(objPath, (0, ramda_1.compose)((0, ramda_1.omit)([last]), (0, ramda_1.path)(objPath))(filtered), filtered);
        });
        return Object.assign(Object.assign({}, schema), { jsonSchema: filtered });
    }, [uiSchema, schema, arrayPropNameToSkip]);
};
exports.usePropertiesFilter = usePropertiesFilter;
const useDefaultWidgetSelect = ({ uiSchema, widgets, currentWidget, handleChangeWidget, cleared }) => {
    const defaultSelectedWidget = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:defaultSelectedWidget'];
    (0, react_1.useEffect)(() => {
        if (!cleared && defaultSelectedWidget != null && !currentWidget && widgets.length) {
            const defaultWidget = widgets.find(({ id, name }) => String(id) === String(defaultSelectedWidget) || name === defaultSelectedWidget);
            if (defaultWidget) {
                setTimeout(() => handleChangeWidget({ value: defaultWidget.id }), 0);
            }
        }
    }, []);
};
exports.useDefaultWidgetSelect = useDefaultWidgetSelect;
//# sourceMappingURL=hooks.js.map